import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#114A4E",
      d: "M12 21.5q-2.535 0-4.142-.727-1.608-.728-1.608-1.879 0-.532.401-1.002.4-.47 1.109-.805l1.18 1.07q-.321.13-.675.322t-.484.406q.247.448 1.476.781 1.227.334 2.738.334t2.751-.334 1.489-.782q-.128-.228-.513-.42a8 8 0 0 0-.731-.322l1.165-1.086q.767.351 1.18.821.414.469.414 1.013 0 1.153-1.608 1.881-1.608.729-4.142.729m.025-4.875q2.485-1.882 3.73-3.73Q17 11.048 17 9.227q0-2.588-1.62-3.908T12.005 4t-3.38 1.32T7 9.23q0 1.701 1.23 3.528t3.795 3.867M12 18.5q-3.273-2.447-4.886-4.754Q5.5 11.44 5.5 9.23q0-1.671.59-2.927.59-1.255 1.522-2.103a6.3 6.3 0 0 1 2.092-1.273 6.6 6.6 0 0 1 2.297-.426q1.137 0 2.296.426t2.092 1.273q.931.847 1.521 2.104.59 1.256.59 2.924 0 2.212-1.613 4.519Q15.273 16.052 12 18.5m.005-7.606q.743 0 1.273-.525t.53-1.278-.531-1.282A1.74 1.74 0 0 0 12 7.279q-.738 0-1.273.53-.535.532-.535 1.277 0 .758.535 1.283.534.525 1.278.525"
    }, null, -1)
  ])))
}
export default { render: render }